import React, { useState } from 'react';
import styled from 'styled-components';

import { Button } from '~/atomic/atom/Button';
import Modal from '~/atomic/molecula/Modal';
import { PageTitleStyle, TextRegStyle } from '~/atomic/Typography';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { choosePayActions } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.slice';
import { ReceiptContactInput } from '~/feature/finance/BuyingSteps/ChoosePay/ReceiptContactInput';
import { validateReceiptContact } from '~/feature/validators';
import { useAppDispatch, useAppSelector } from '~/store';

export const ConfirmContactModal = ({ onOk }: { onOk: () => void }) => {
  const [contact, setContact] = useState('');
  const [contactError, setContactError] = useState('');
  const dispatch = useAppDispatch();
  const { isConfirmContactModal, isPayLoading } = useAppSelector(choosePaySelector);

  const closeModal = () => {
    dispatch(choosePayActions.setIsConfirmContactModal(false));
  };

  const validateContact = (value: string) => {
    const error = validateReceiptContact(value);
    setContactError(error);
    return !error;
  };

  const changeContactHandler = (value: string) => {
    setContact(value);
    if (!value) {
      setContactError('');
    } else if (contactError) {
      validateContact(value);
    }
  };

  const buyHandler = async () => {
    if (!validateContact(contact)) {
      return;
    }
    dispatch(choosePayActions.changeReceiptContact(contact));
    dispatch(choosePayActions.setIsConfirmContactModal(false));
    await onOk();
  };

  return (
    <SCBuyModal
      open={isConfirmContactModal}
      onCancel={closeModal}
    >
      <SCTitle>
        Оплата доступа к книге
      </SCTitle>
      <SCDescription>
        Для отправки чека укажите ваш e-mail или номер телефона
      </SCDescription>
      <SCContactField>
        <ReceiptContactInput
          value={contact}
          onChange={changeContactHandler}
          onPressEnter={buyHandler}
          error={contactError}
          autoFocus
        />
      </SCContactField>
      <SCBuyBookButton
        type="primary"
        size="large"
        onClick={buyHandler}
        isLoading={isPayLoading}
      >
        Перейти к оплате
      </SCBuyBookButton>
    </SCBuyModal>
  );
};

const SCBuyModal = styled(Modal)`
  width: 530px !important;
`;

const SCTitle = styled.h3`
  ${PageTitleStyle};
  color: var(--black-color);
  margin-bottom: 12px;
`;

const SCDescription = styled.p`
  ${TextRegStyle};
  color: var(--gray-color);
  margin-bottom: 8px;
`;

const SCContactField = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 380px;
  width: 100%;
`;

const SCBuyBookButton = styled(Button)`
  max-width: 260px;
  width: 100%;
  height: 48px;
  font-size: 16px;
  margin: 32px auto 0;
`;
